import { BreakpointObserver } from '@angular/cdk/layout';
import { Injectable, inject } from '@angular/core';
import { Keyboard } from '@capacitor/keyboard';
import { Platform } from '@ionic/angular';
import { createEffect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { debounceTime, map } from 'rxjs';

import { ViewportActions } from './viewport.actions';
import { NinetyBreakpointNames, NinetyBreakpoints } from './viewport.model';

@Injectable({ providedIn: 'root' })
export class ViewportStateEffects {
  private readonly breakpointObserver = inject(BreakpointObserver);
  private readonly store = inject(Store);
  private readonly platform = inject(Platform);

  constructor() {
    window?.addEventListener('resize', () => {
      const pageHeight = window?.innerHeight ?? 0;
      const pageWidth = window?.innerWidth ?? 0;
      this.store.dispatch(ViewportActions.resizeSet({ pageHeight, pageWidth }));
    });

    if (this.platform.is('capacitor')) {
      Keyboard.addListener('keyboardWillShow', () => {
        this.store.dispatch(ViewportActions.keyboardVisibilityChanged({ keyboardVisible: true }));
      });
      Keyboard.addListener('keyboardWillHide', () => {
        this.store.dispatch(ViewportActions.keyboardVisibilityChanged({ keyboardVisible: false }));
      });
    }
  }

  observeBreakpoints$ = createEffect(() => {
    let breakpointNames: NinetyBreakpointNames[] | null = null;
    return this.breakpointObserver.observe(Object.values(NinetyBreakpoints)).pipe(
      debounceTime(150),
      map(breakpointState => {
        if (!breakpointNames) breakpointNames = Object.keys(NinetyBreakpoints) as NinetyBreakpointNames[];
        const matchingBreakpointIdx = breakpointState.matches
          ? Object.values(breakpointState.breakpoints).lastIndexOf(true)
          : breakpointNames.indexOf(NinetyBreakpointNames.Medium);
        const currentScreenSize = breakpointNames[matchingBreakpointIdx];
        return ViewportActions.breakpointSet({ breakpointState, currentScreenSize });
      })
    );
  });
}
